<!-- <template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
      <router-view/>
  </div>
</template> -->



<template>
  <div class="tutorial-wrapper">

        <div class="fab red" v-if="requiresInteraction && !hasInteractedWithCurrentTab">User action needed</div>
        <div class="fab green" v-else>User action needed</div>
        <!-- <div class="fab red" v-if="requiresInteraction && !hasInteractedWithCurrentTab">Tab {{currentActive + 1}} Needs user action</div> -->
        <!-- <div class="fab green" v-else>No interaction required on Tab {{currentActive + 1}}</div> -->

        <div class="pageStatus">
          <ul>
            <li v-for="(page, index) in pageStatus" :key="index">Page {{index + 1}} {{page.needsInteraction}} / {{page.hasInteracted}}</li>
          </ul>
        </div>

        <div class="tab-details">
            <tab name="Step 1" :selected="true">
                <PageIntro :interactionNeeded="interactionNeeded" v-on:sendData="getSentData"></PageIntro>
            </tab>
            <tab name="Step 2">
               <PageWhySMS :interactionNeeded="interactionNeeded" v-on:sendData="getSentData"></PageWhySMS>
            </tab>
            <tab name="Step 3">
               <PageSMSContent :interactionNeeded="interactionNeeded" v-on:sendData="getSentData"></PageSMSContent>
            </tab> 
            <tab name="Step 4">
                <PageIntroToHazards :interactionNeeded="interactionNeeded" v-on:sendData="getSentData"></PageIntroToHazards>
            </tab>
            <tab name="Step 5">
                <PageRiskAssessment :interactionNeeded="interactionNeeded" v-on:sendData="getSentData"></PageRiskAssessment>
            </tab> 
            <tab name="Step 6">
                <PageLogsIntro :interactionNeeded="interactionNeeded" v-on:sendData="getSentData"></PageLogsIntro>
            </tab>
            <tab name="Step 7">
               <PageDailyStartup :interactionNeeded="interactionNeeded" v-on:sendData="getSentData"></PageDailyStartup>
            </tab> 
            <tab name="Step 8">
               <PageFinished :interactionNeeded="interactionNeeded" v-on:sendData="getSentData"></PageFinished>
            </tab> 
            <tab name="Step 9">
               <PageFive :interactionNeeded="interactionNeeded" v-on:sendData="getSentData"></PageFive>
            </tab> 
        </div>


        <div class="footer-nav">

          <div class="nav-outer left">
            <div class="nav-previous active" @click="changeTab(--currentActive,'slide-right')" v-if="currentActive > 0" ><span><font-awesome-icon icon="chevron-left" /> Previous</span></div>
            <div class="nav-previous" v-else><span><font-awesome-icon icon="chevron-left" /> Previous</span></div>
          </div>

          <div  class="nav-outer right">
            <div class="nav-next active" v-if="currentActive == totalTabs - 1" @click="finished()"><span>Done <font-awesome-icon icon="home" /></span></div>
            <div class="nav-next active" @click="changeTab(++currentActive,'slide-left')" v-if="currentActive < totalTabs - 1 && hasInteractedWithCurrentTab"><span>Next <font-awesome-icon icon="chevron-right" /></span></div>
            <div class="nav-next" v-else><span>Next <font-awesome-icon icon="chevron-right" /></span></div>
          </div>

          <div class="clear"></div>

          <!-- <button @click="changeTab(--currentActive,'slide-right')" v-if="currentActive > 0">Previous</button>
          <button @click="changeTab(++currentActive,'slide-left')" v-if="currentActive < totalTabs - 1">Next</button>
          <button v-if="currentActive == totalTabs -1">Done</button>
          <p>Num: {{currentActive + 1}}</p> -->

        </div>


  </div>
</template>



<script>
  




const PageIntroToHazards = () => import('../views/PageIntroToHazards.vue');
const PageIntro = () => import('../views/PageIntro.vue');
const PageSMSContent = () => import('../views/PageSMSContent.vue');
const PageWhySMS = () => import('../views/PageWhySMS.vue');
const PageDailyStartup = () => import('../views/PageDailyStartup.vue');
const PageLogsIntro = () => import('../views/PageLogsIntro.vue');
const PageFive = () => import('../views/PageFive.vue');
const PageFinished = () => import('../views/PageFinished.vue');
const PageRiskAssessment = () => import('../views/PageRiskAssessment.vue');


export default {

  components: {
    PageIntroToHazards,
    PageIntro,
    PageSMSContent,
    PageWhySMS,
    PageDailyStartup,
    PageLogsIntro,
    PageFive,
    PageFinished,
    PageRiskAssessment
  },

  data() {
    return {
      transitionName: 'slide-right',
      tabs: [],
      currentActive: 0,
      totalTabs: 6,
      tempValue: 'hello steve',
      hasInteractedWithCurrentTab: true,
      requiresInteraction: false,
      interactionNeeded: false,
      pageStatus: [
        {needsInteraction: false, hasInteracted: false}, // page one
        {needsInteraction: false, hasInteracted: false}, // page seven?
        {needsInteraction: false, hasInteracted: false}, // page one
        {needsInteraction: false, hasInteracted: false}, // page two
        {needsInteraction: false, hasInteracted: false}, // page three
        {needsInteraction: false, hasInteracted: false}, // page four
        {needsInteraction: false, hasInteracted: false}, // page five
        {needsInteraction: false, hasInteracted: false}, // page six 
        {needsInteraction: false, hasInteracted: false},
      ],
    }
  },

  created() {
      this.tabs = this.$children;
      
  },

  mounted() {
      this.totalTabs = this.tabs.length;
  },

  methods:{

      changeTab(makeTabActive,slideMode) {
          this.tabs.forEach(tab => {
             tab.isActive = false;
          });

          // this.checkInteraction = slideMode == 'slide-left' ? true : false;
          // this.hasInteractedWithCurrentTab = slideMode == 'slide-left' ? false : true;

          window.scrollTo(0, 0);

          this.interactionNeeded = this.pageStatus[this.currentActive].needsInteraction;
          
          this.tabs[makeTabActive].slideType = slideMode;
          this.tabs[makeTabActive].isActive = true;
          this.tabs[makeTabActive].slideType = slideMode;

      },

      getSentData: function(result) {
        console.log('Returned Data:',result);
        this.hasInteractedWithCurrentTab = result.hasInteracted;
        this.pageStatus[this.currentActive].hasInteracted = result.hasInteracted;
      },

      finished: function() {
        this.$router.push('/');
      }


  },

  watch: {
    currentActive() {
      if (this.pageStatus[this.currentActive].needsInteraction && !this.pageStatus[this.currentActive].hasInteracted) {
        this.hasInteractedWithCurrentTab = false;
      } else {
        this.hasInteractedWithCurrentTab = true;
      }
    }
  }

  // watch: {
  //   $route (to, from) {
  //     const toDepth = to.path.split('/').length
  //     const fromDepth = from.path.split('/').length
  //     console.log('Depth',toDepth,fromDepth);
  //     this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
  //   }
  // }

}


</script>



<style lang="scss">



.slide-left-enter {
  opacity: 0;
  // transform: scale3d(2, 0, 1) translate3d(100%, -50%, 0);
  transform: translateX(100%);
}
.slide-left-enter-active {
  // transition: 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transition: 0.5s ease-in;
}
.slide-left-enter-to {
  transform: scale3d(1, 1, 1);
}
.slide-left-leave {
  // transition: 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.slide-left-leave-active {

}
.slide-left-leave-to {
  
}





.slide-right-enter {
  opacity: 0;
  // transform: scale3d(2, 0, 1) translate3d(-100%, -50%, 0);
  transform: translateX(-100%);
}
.slide-right-enter-active {
  // transition: 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transition: 0.5s ease-in;
}
.slide-right-enter-to {
  transform: scale3d(1, 1, 1);
}
.slide-right-leave {
  // transition: 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transition: 0.5s ease-out;
}
.slide-right-leave-active {

}
.slide-right-leave-to {
  
}



.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}



#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.fab {
  display: none;
  position: fixed;
  right: 20px;
  bottom: 100px;
  background: #ddd;
  color: #c60;
  color: white;
  padding: 1rem;
  z-index: 999;
  transition: 0.3s;
  opacity: 1.0;
  &.red {
    background: indianred;
    color: white;
    border-radius: 5px;
  }
  &.green {
    //background: green;
    opacity: 0;
  }
}

.pageStatus {
  display: none;
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: lightgreen;
  padding: 1rem;
}


</style>
